"use client";

import { MoneyChange } from "iconsax-reactjs";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { ResponsiveModal } from "@/components/features/staking/ResponsiveModal";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ConvertDialogForm } from "./ConvertDialogForm";

interface ConvertDialogProps {
  buttonClassName?: string;
}

export const ConvertDialog = ({ buttonClassName }: ConvertDialogProps) => {
  const t = useTranslations("modals");
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        type="button"
        variant="solid"
        colors="secondary"
        size="sm"
        startIcon={<MoneyChange size={16} />}
        className={cn("shrink-0", buttonClassName)}
        onClick={() => setOpen(true)}
      >
        {t("convert.triggerButton")}
      </Button>
      <ResponsiveModal
        open={open}
        onOpenChange={setOpen}
        title={t("convert.assetTitle")}
      >
        <ConvertDialogForm onSuccess={() => setOpen(false)} />
      </ResponsiveModal>
    </>
  );
};
